export type ContentType = {
  html: string;
  plaintext: string;
};

export const hasTags = (html: string) =>
  /<[^>]+>/.test(
    html.replace(/<br>/gi, '').replace(/^<(\w+)>([\s\S]*)<\/\1>$/, '$2')
  );

export const getText = ({ html = '', plaintext = '' }: ContentType) => {
  return hasTags(html) ? html : plaintext;
};

export const getContentBasedOnType = (
  content: ContentType,
  type: 'html' | 'plaintext'
) => content[type];

export const slugify = (
  text: string | null | undefined,
  textToExclude?: string
) => {
  if (!text) return '';

  if (textToExclude) {
    text = text.replace(textToExclude, '');
  }

  const slugifyRegex = {
    nonWord: /[^\w\s-]/g,
    nonWordUnicode: /[^\p{L}\p{N}\s-]/gu,
    multiHyphen: /[\s_-]+/g,
    trimHyphen: /^(?:(?:-+)|(?:-+))$/g,
  };

  const normalized = text.toString().normalize('NFD');

  const cleaned = normalized
    .replace(/[\u0300-\u036f]/g, '')
    .replace(slugifyRegex.nonWordUnicode, '');

  return cleaned
    .toLowerCase()
    .trim()
    .replace(slugifyRegex.multiHyphen, '-')
    .replace(slugifyRegex.trimHyphen, '');
};

// This function converts a string to title case, where the first letter of each word is capitalized.
export const convertToTitleCase = (text: string, delimiter: string = '-') => {
  return text
    ? text
        .split(delimiter)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    : '';
};
